import { createFileRoute, redirect } from '@tanstack/react-router'

/** Seção sem tela própria: manda para a primeira tab. */
export const Route = createFileRoute('/_authed/configuracoes/')({
  beforeLoad: () => {
    throw redirect({ to: '/configuracoes/empresa' })
  },
})
